import {
  Button,
  CircularProgress,
  Tooltip
} from '@mui/material';
import { Create } from '@mui/icons-material';
import { FC, useState } from "react";
import ChangePercentageVirtualBatteryDialog from './ChangeBatteryPercentageDialog';
import useAuth from '@/components/Authentication/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { useVirtualBatteries } from '../../hooks/useVirtualBatteries';

interface ChangeBatteryPercentageDialogOpenButtonParams {
  polissaBateriaId: number
}

const ChangeBatteryPercentageDialogOpenButton: FC<ChangeBatteryPercentageDialogOpenButtonParams> = ({
  polissaBateriaId
}) => {
  const { t } = useTranslation();
  const { 
    isBateriaVirtualActive 
  } = useVirtualBatteries();
  const { tokenVals } = useAuth();

  const [ dialogOpen, setDialogOpen ] = useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };


  const renderButton = (
    <div>
      <Tooltip
        title={tokenVals?.readonly &&
          t("common:text.token_readonly_tooltip")
        }
        placement="right"
        arrow
        disableFocusListener={!tokenVals?.readonly}
        disableHoverListener={!tokenVals?.readonly}
        disableTouchListener={!tokenVals?.readonly}
        slotProps={{
          popper: {
            modifiers: [{
              name: 'offset',
              options: {offset: [0, -5]}
            }]
          }
        }}
      >
        <span>
          <Button
            variant={'contained'}
            color={'primary'}
            onClick={handleDialogOpen}
            disabled={!!tokenVals?.readonly || !isBateriaVirtualActive(polissaBateriaId)}
            startIcon={<Create />}
          >
            { t('common:text.solar_wallet.modify_percentage') }
          </Button>
        </span>
      </Tooltip>
      <ChangePercentageVirtualBatteryDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        polissaBateriaId={polissaBateriaId}
      />
    </div>
  );

  if (!isBateriaVirtualActive(polissaBateriaId)) {
    return (
      <Tooltip title={t('common:text.solar_wallet.not_actived_because_of_dates')}>
        {renderButton}
      </Tooltip>
    );
  }
  return renderButton;

}


export default ChangeBatteryPercentageDialogOpenButton;
